import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

type FileListContainerProps = {
  sameHeightFileList?: boolean
}

export const FileListContainer = styled.div<FileListContainerProps>`
  display: flex;
  width: 100%;
  height: ${({ sameHeightFileList }) => (sameHeightFileList ? '160px' : '275px')};
  border: 1px solid ${Color.Grey200};
  border-radius: 10px;
  position: relative;
  box-shadow: 0 1px 3px ${transparentize(0.85, Color.Grey500)};
  overflow: auto;
`

export const FileListScrollableArea = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: ${Spacing.S12};
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${Color.White};
  overflow: auto;
`

export const FileItem = styled.li`
  display: flex;
  align-items: center;
  gap: ${Spacing.S6};
  width: 100%;

  & + & {
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid ${Color.Grey200};
  }
`

export const ButtonWrapper = styled.div`
  flex-shrink: 0;
  margin-left: ${Spacing.S8};
`

export const CloseButton = styled.span`
  margin-left: auto;
  cursor: pointer;
`
